import React from 'react';

import { gettext } from '@eventbrite/i18n';
import type { CalendarProps, FooterSignalProps } from '@eventbrite/timed-entry';
import type { DateAvailabilityStatus } from '../../../state/infiniteCalendarSeries';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../../utils/rebrand';
import { DiscountSvg } from '../assests/DiscountSvg';
import { SoldOutIconSvg } from '../assests/SoldOutIconSvg';
import { COLORS } from '../colorConstants';
import defaultStyles from './CalendarContainer.module.scss';
import rebrandStyles from './CalendarContainer.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

export const getCalendarDateCellProps = (
    isAppRebrandActive: boolean,
): CalendarProps<DateAvailabilityStatus>['dateCellProps'] => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];
    return {
        available: {
            icon: null,
            enabled: true,
            className: styles.availableDateCell,
        },
        discount: {
            icon: (
                <DiscountSvg
                    fill={
                        isAppRebrandActive
                            ? COLORS['blue-300']
                            : COLORS['orange-500']
                    }
                />
            ),
            enabled: true,
        },
        soldOut: {
            icon: <SoldOutIconSvg />,
            enabled: false,
            className: styles.soldOutDateCell,
        },
        highDemand: {
            enabled: true,
            icon: null,
            className: styles.highDemandDateCell,
        },
        unavailable: {
            enabled: false,
            icon: null,
            className: styles.unavailableDateCell,
        },
    };
};

export const getFooterSignals = (
    isAppRebrandActive: boolean,
): Array<FooterSignalProps> => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];
    return [
        {
            icon: (
                <DiscountSvg
                    fill={
                        isAppRebrandActive
                            ? COLORS['blue-300']
                            : COLORS['orange-500']
                    }
                />
            ),
            className: styles.discountFooter,
            text: gettext('Discount').toString(),
        },
        {
            className: styles.highDemandFooter,
            text: gettext('High demand').toString(),
        },
        {
            icon: <SoldOutIconSvg />,
            className: styles.soldOutFooter,
            text: gettext('Sold out').toString(),
        },
    ];
};
